import type { LC_AsyncJobProcessCatalogItemOut, AsyncJobProcess } from './asyncJobProcess.types.ts';


export function mapAsyncJobProcessOutToModel(
  item: LC_AsyncJobProcessCatalogItemOut,
): AsyncJobProcess {
  return {
    code: item.code,
    label: item.label,
  };
}
